<div class="card-body table-responsive">
  <table class="table table-hover table-centered mb-0">
    <thead>
      <tr>
        <th class="text-primary-emphasis">{{ 'waTemplate.webhook.templateName' | translate }}</th>
        <th class="text-primary-emphasis">{{ 'waTemplate.webhook.preview' | translate }}</th>
        <th class="text-primary-emphasis">{{ 'waTemplate.webhook.category' | translate }}</th>
        <th class="text-primary-emphasis">{{ 'waTemplate.webhook.language' | translate }}</th>
        <th><span class="sr-only"></span></th>
      </tr>
    </thead>
    <tbody>
      @for (template of templates; track $index) {
        <tr>
          <td>{{ template.name }}</td>
          <td>{{ getBodyText(template) | slice : 0 : 50 }}</td>
          <td>
            @if (template.category === 'MARKETING') {
              <span class="badge bg-info">{{ 'waTemplate.webhook.categoryMarketing' | translate }}</span>
            }
            @if (template.category === 'UTILITY') {
              <span class="badge bg-secondary">{{ 'waTemplate.webhook.categoryUtility' | translate }}</span>
            }
            @if (template.category === 'AUTHENTICATION') {
              <span class="badge bg-success">{{ 'waTemplate.webhook.categoryAuthentication' | translate }}</span>
            }
            @if (template.category !== 'MARKETING' && template.category !== 'UTILITY' && template.category !== 'AUTHENTICATION') {
              <span class="badge bg-light text-dark">
                {{ template.category }}
              </span>
            }
          </td>

          <td>
            @switch (template.language) {
              @case ('pt_BR') {
                <div class="d-flex align-items-center gap-2">
                  <img width="18" src="../../../../assets/icons/br.svg" [alt]="'waTemplate.webhook.languagePortuguese' | translate" />
                  <small class="text-muted">{{ 'waTemplate.webhook.languagePortuguese' | translate }}</small>
                </div>
              }
              @case ('en_US') {
                <div class="d-flex align-items-center gap-2">
                  <img width="18" src="../../../../../../../assets/icons/us.svg" [alt]="'waTemplate.webhook.languageEnglish' | translate" />
                  <small class="text-muted">{{ 'waTemplate.webhook.languageEnglish' | translate }}</small>
                </div>
              }
              @default {
                <small>{{ template.language }}</small>
              }
            }
          </td>

          <td class="text-end">
            <button type="button" class="btn btn-outline-primary btn-sm" (click)="showTemplateDetails(template)">
              {{ 'waTemplate.webhook.selectButton' | translate }}
            </button>
          </td>
        </tr>
      }
    </tbody>
  </table>
</div>